/**
 * Faz 9 (yapay zekâ, öneriler, talep tahmini) arayüz ve hata metinleri — Türkçe.
 *
 * Faz 8 ayrı dalda geliştirildiği için bu fazın metinleri ayrı dosyada tutulur (birleştirmede çakışma azalsın).
 * `ui` → `ai.*` ad alanı; diğer bölümler tr.ts'teki ilgili blokların (errors, permissions…) başına yayılır.
 */
export const aiTr = {
  ui: {
    nav: {
      group: 'Yapay zekâ',
      settings: 'Yapay zekâ ayarları',
      recommendations: 'Ürün önerileri',
      forecast: 'Talep tahmini',
      studio: 'İçerik Stüdyosu',
      copilot: 'Copilot (iş asistanı)',
      seo: 'SEO önerileri',
      ltv: 'Tahmini müşteri değeri',
      youtube: 'YouTube videoları',
    },
    availability: {
      ready: 'Hazır',
      not_configured: 'Kurulum Gerekli',
      disabled: 'Kapalı (sahip onayı bekliyor)',
      budget_exhausted: 'Aylık sınır doldu',
      daily_limit: 'Günlük istek sınırı doldu',
    },
    purposes: {
      product_description: 'Ürün açıklaması',
      merchant_title: 'Google ürün başlığı',
      translation: 'Çeviri',
      article_plan: 'Makale planı',
      article_headings: 'Makale başlıkları',
      article_draft: 'Makale taslağı',
      article_meta: 'SEO başlığı ve açıklaması',
      alt_text: 'Görsel alt metni',
      image: 'Görsel üretimi',
      email_draft: 'E-posta taslağı',
      ad_copy: 'Reklam metni',
      ad_suggestions: 'Reklam önerileri',
      support_reply: 'Destek yanıt taslağı',
      copilot: 'Copilot',
    },
    requestStatus: { pending: 'Sürüyor', ok: 'Tamamlandı', error: 'Hata' },
    providerNames: { anthropic: 'Anthropic Claude', openai: 'OpenAI Images' },
    recommendations: {
      statusTitle: 'Durum',
      statusLead:
        "Öneriler yapay zekâ kullanmaz ve ücretsizdir: mağazanın ödenmiş gerçek siparişlerinden her gece 04:25'te hesaplanır. Veri yetersizse vitrinde ilgili bölüm görünmez.",
      run: 'Şimdi hesapla',
      ran: '{{orders}} sipariş değerlendirildi, {{pairs}} ilişki kaydedildi.',
      stats: '{{pairs}} ilişki · önerisi olan {{products}} ürün',
      runsTitle: 'Son hesaplamalar',
      when: 'Zaman',
      trigger: 'Başlatan',
      scheduled: 'Gece işi',
      manualBy: 'Elle ({{name}})',
      orders: 'Sipariş',
      pairsKept: 'Saklanan / bulunan ilişki',
      result: 'Sonuç',
      status: { ok: 'Tamamlandı', error: 'Hata' },
      noStore: 'Mağaza yok',
      noStoreLead:
        'Öneriler mağaza bazında hesaplanır. Önce İşletme → Mağazalar ekranından bir mağaza oluşturun.',
      noRuns: 'Henüz hesaplama yapılmadı.',
      settingsTitle: 'Ayarlar',
      toggles: {
        alsoBought: 'Ürün sayfasında "Bunu alanlar bunları da aldı"',
        cart: 'Sepette "Sepetinize eklenebilecekler"',
        replenishment: 'Hesabım\'da "Yeniden alım zamanı"',
        includeB2b: 'Bayi siparişlerini de say',
      },
      toggleHints: {
        alsoBought: 'Bu ürünle aynı siparişte sık alınan ürünler (tamamlayıcı ürünler tekrar edilmez).',
        cart: 'Sepetteki ürünlerle sık alınanlar; sepette olanlar gösterilmez.',
        replenishment:
          'Düzenli alınan ürünlerin tahmini yeniden alım tarihi (yalnızca müşterinin kendisine).',
        includeB2b: 'Toptan alımlar perakende ilişkilerini bozabilir; varsayılan kapalı.',
      },
      windowDays: 'Değerlendirilen dönem (gün)',
      minPairBuyers: 'En az farklı alıcı',
      minPairBuyersHint:
        'Bir ilişki ancak bu kadar farklı müşterinin siparişinde birlikte geçtiyse kullanılır (tek kişinin alışverişi öneriden okunamasın). En az 2.',
      minConfidence: 'En az güven (%)',
      minConfidenceHint:
        'Ürünü alanların yüzde kaçı diğerini de aldı. Düşükse rastlantısal ilişkiler elenir.',
      maxPerProduct: 'Ürün başına en çok öneri',
      save: 'Ayarları kaydet',
      saved: 'Ayarlar kaydedildi. Değişiklik bir sonraki hesaplamada geçerli olur.',
      pairsTitle: 'En güçlü ilişkiler',
      pairsLead:
        "Her ürünün en güçlü ilişkisi. Güven: ürünü alanların diğerini de alma oranı. Kaldıraç: rastlantıya göre kaç kat sık birlikte alındığı (1'in üstü).",
      product: 'Ürün',
      related: 'Birlikte alınan',
      buyers: 'Farklı alıcı',
      confidence: 'Güven',
      lift: 'Kaldıraç',
      noPairs: 'Henüz öneri yok',
      noPairsLead:
        'Yeterli sipariş birikince (aynı iki ürünü birlikte alan en az birkaç farklı müşteri) öneriler kendiliğinden oluşur.',
    },
    forecast: {
      lead: 'Yapay zekâ kullanmaz: ödenmiş, iptal edilmemiş gerçek siparişlerin haftalık satışından her açılışta hesaplanır. Açık satın alma siparişlerinde teslim alınmamış adet önerilen miktardan düşülür. Mevsim ve kampanya etkisi hesaba katılmaz; satın alma emri oluşturmaz.',
      counts: {
        stockout: 'Tükendi',
        reorder: 'Sipariş zamanı',
        on_order: 'Siparişi verildi',
        expiry_risk: 'SKT riski',
        overstock: 'Fazla stok',
        ok: 'Yeterli',
        no_sales: 'Satış yok',
      },
      accuracy: 'Son 4 haftada tahmin hatası (WAPE): %{{pct}} · {{count}} varyant',
      accuracyNone: 'Doğruluk ölçmek için en az 8 haftalık satış geçmişi gerekir.',
      totalSuggested: 'Toplam önerilen sipariş: {{count}} adet',
      totalOnOrder: 'Yolda ve talepte: {{count}} adet',
      filterStatus: 'Durum',
      all: 'Tümü',
      search: 'Ürün veya stok kodu ara',
      csv: 'CSV indir',
      product: 'Ürün',
      sold28: 'Son 28 gün',
      daily: 'Günlük tahmin',
      available: 'Satılabilir stok',
      onOrder: 'Yolda',
      requestedNote: 'talepte {{count}}',
      cover: 'Yeterlilik',
      coverDays: '{{days}} gün',
      suggested: 'Önerilen sipariş',
      status: 'Durum',
      method: 'Yöntem',
      methods: {
        none: 'Satış yok',
        new: 'Yeni ürün (ortalama)',
        ses: 'Düzenli (üstel düzeltme)',
        croston: 'Aralıklı (Croston)',
      },
      expiry: 'SKT riski: {{lot}} lotu {{date}} — {{count}} adet satılamayabilir',
      excluded: 'Tahminden çıkarıldı',
      customSafety: 'Özel emniyet stoğu: {{days}} gün',
      leadLine: 'Tedarik süresi {{days}} gün ({{source}})',
      leadSources: {
        variant: 'ürüne özel',
        supplier: 'tedarikçiden',
        supplierNamed: 'tedarikçi: {{name}}',
        default: 'varsayılan',
      },
      adjust: 'Ayarla',
      empty: 'Gösterilecek ürün yok',
      emptyLead: 'Etkin ürün varyantı olmadığında veya süzgeçle eşleşen ürün kalmadığında liste boştur.',
      variantTitle: '{{product}} — tahmin ayarı',
      leadTime: 'Tedarik süresi (gün)',
      safety: 'Emniyet stoğu (gün)',
      defaultHint: 'Boş bırakılırsa işletme varsayılanı ({{days}} gün) kullanılır.',
      supplierHint:
        'Boş bırakılırsa son satın alma siparişinin tedarikçisindeki teslim süresi ({{days}} gün) kullanılır.',
      exclude: 'Tahminden çıkar (bir kerelik veya satışı durdurulan ürün)',
      variantSaved: 'Varyant ayarı kaydedildi.',
      settingsTitle: 'Varsayılanlar',
      historyWeeks: 'Değerlendirilen geçmiş (hafta)',
      defaultLead: 'Varsayılan tedarik süresi (gün)',
      defaultSafety: 'Varsayılan emniyet stoğu (gün)',
      reviewDays: 'Gözden geçirme dönemi (gün)',
      reviewHint:
        'Önerilen miktar, stoğun tedarik süresi + emniyet + bu dönem kadar talebe yetmesini hedefler.',
      overstockDays: 'Fazla stok eşiği (gün)',
      includeB2b: 'Bayi siparişlerini de talebe say',
      save: 'Varsayılanları kaydet',
      saved: 'Varsayılanlar kaydedildi.',
    },
    studio: {
      lead: 'Makaleyi 27 adımlık süreçle hazırlayın: konu ve kaynaklardan plana, taslaktan SEO ve görsellere, kalite kontrolünden yayın sonrası performansa. Yapay zekâ adımları isteğe bağlıdır; her alan elle de doldurulabilir. Yayın, editör ve veteriner onayı blog ekranında yapılır.',
      create: 'Yeni makale projesi',
      createTitle: 'Yeni makale projesi',
      createSubmit: 'Projeyi oluştur',
      filter: 'Göster',
      filters: { active: 'Süren projeler', exported: 'Bloga aktarılanlar', archived: 'Arşiv' },
      statuses: { draft: 'Hazırlanıyor', exported: 'Bloga aktarıldı', archived: 'Arşivde' },
      empty: 'Henüz makale projesi yok',
      emptyLead: '"Yeni makale projesi" ile konu ve hedef kitleyi yazarak başlayın.',
      words: '{{count}} kelime',
      updated: '{{date}} · {{name}}',
      healthBadge: 'Sağlık içeriği',
      aiAssisted: 'Yapay zekâ destekli',
      back: 'Tüm projeler',
      save: 'Kaydet',
      saved: 'Proje kaydedildi.',
      unsaved: 'Kaydedilmemiş değişiklikler var.',
      saveFirst: 'Önce değişiklikleri kaydedin.',
      stepsTitle: 'Süreç: {{done}} / {{total}} adım',
      stepDone: 'tamamlandı',
      stepOpen: 'bekliyor',
      stepAi: 'Bu adımda yapay zekâ kullanıldı',
      steps: {
        topic: 'Konu',
        audience: 'Hedef kitle',
        market: 'Hedef ülke ve dil',
        keyword: 'Anahtar kelime',
        intent: 'Arama niyeti',
        sources: 'Kaynaklar',
        duplicates: 'Tekrar kontrolü',
        plan: 'Makale planı',
        headings: 'H2/H3 başlıklar',
        draft: 'Taslak',
        sourceCheck: 'Kaynak doğrulama',
        internalLinks: 'İç bağlantılar',
        relatedProducts: 'İlgili ürünler',
        seoTitle: 'SEO başlığı',
        metaDescription: 'Meta açıklama',
        slug: 'Adres (slug)',
        category: 'Kategori',
        tags: 'Etiketler',
        schema: 'Yapılandırılmış veri',
        cover: 'Kapak görseli',
        images: 'İçerik görselleri',
        altText: 'Alt metinler',
        quality: 'Kalite kontrolü',
        approval: 'Editör ve veteriner onayı',
        schedule: 'Yayın / zamanlama',
        performance: 'Performans takibi',
        updates: 'Güncelleme önerileri',
      },
      sec: {
        brief: 'Konu ve hedef (adım 1–5)',
        research: 'Kaynaklar ve tekrar kontrolü (adım 6, 7, 11)',
        outline: 'Plan ve başlıklar (adım 8–9)',
        draft: 'Taslak, iç bağlantılar ve ilgili ürünler (adım 10, 12–13)',
        seo: 'SEO (adım 14–19)',
        images: 'Görseller (adım 20–22)',
        quality: 'Kalite kontrolü (adım 23)',
        publish: 'Onay ve yayın (adım 24–25)',
        performance: 'Performans ve güncelleme (adım 26–27)',
      },
      f: {
        title: 'Çalışma başlığı',
        topic: 'Konu',
        topicHint:
          'Yazının cevaplayacağı soru veya ele alacağı konu (ör. "Kedilerde omega-3 takviyesi nasıl seçilir").',
        audience: 'Hedef kitle',
        country: 'Hedef ülke',
        countryHint: 'İki harfli ülke kodu (TR, DE…).',
        keyword: 'Anahtar kelime',
        keywordPool: 'Anahtar kelime havuzundan seç',
        keywordNone: 'Seçilmedi (elle yazın)',
        intent: 'Arama niyeti',
        intentNone: 'Belirtilmedi',
        health: 'Sağlık / takviye içeriği (veteriner onayı gerekir)',
        sourceUrl: 'Kaynak adresi',
        sourceTitle: 'Kaynak adı',
        sourceNote: 'Not',
        plan: 'Plan',
        headings: 'Başlıklar',
        headingLevel: 'Düzey',
        headingText: 'Başlık',
        draft: 'Taslak (Markdown)',
        draftHint:
          '{{count}} kelime. ## ile H2, ### ile H3; [metin](/urun/adres) ile iç bağlantı. Ham HTML çalıştırılmaz.',
        relatedProducts: 'İlgili ürünler',
        seoTitle: 'SEO başlığı',
        slug: 'Adres',
        metaDescription: 'Meta açıklama',
        category: 'Blog kategorisi',
        categoryNone: 'Kategorisiz',
        tags: 'Etiketler',
        tagsHint: 'Virgülle ayırın (en çok 10).',
        cover: 'Kapak görseli',
        coverAlt: 'Kapak alt metni',
        images: 'İçerik görselleri',
        imageReplace: 'Görseli değiştir',
        imageAlt: 'Alt metin',
        imageAdd: 'Görsel ekle',
        aiDisclosure: 'Yazının sonuna "yapay zekâ desteğiyle hazırlandı" notu ekle',
      },
      intents: {
        informational: 'Bilgi arıyor',
        commercial: 'Karşılaştırıyor',
        transactional: 'Satın almak istiyor',
        navigational: 'Belirli bir sayfayı arıyor',
      },
      sourcesLead:
        'Yazıda dayanılacak kaynakları ekleyin. Yapay zekâ yalnızca bu kaynaklara atıf yapabilir; kaynak, istatistik veya çalışma uyduramaz. Kaynaklar blog yazısının "Kaynaklar" bölümüne aktarılır.',
      addSource: 'Kaynak ekle',
      removeSource: 'Kaynağı kaldır',
      verify: 'Kaynakları doğrula',
      verified: 'Kaynaklar kontrol edildi.',
      checkedAt: '{{date}} kontrol edildi',
      sourceStatus: {
        ok: 'Erişilebilir',
        unreachable: 'Erişilemedi',
        blocked: 'Engellendi (iç ağ)',
        http_error: 'Sayfa hata verdi',
        not_html: 'Sayfa değil',
        invalid_url: 'Geçersiz adres',
      },
      duplicatesTitle: 'Tekrar kontrolü',
      duplicatesNotChecked: 'Henüz kontrol edilmedi.',
      duplicatesNone: 'Mağazada benzer başlıklı yazı veya sayfa bulunmadı.',
      duplicatesChecked: 'Tekrar kontrolü yapıldı.',
      similarity: '%{{pct}} benzer',
      checkDuplicates: 'Benzer içerik ara',
      aiPlan: 'Yapay zekâ ile plan ve başlık',
      aiDraft: 'Yapay zekâ ile taslak',
      aiMeta: 'Yapay zekâ ile SEO önerisi',
      aiDone: 'Yapay zekâ önerisi kaydedildi. Gözden geçirip düzenleyin.',
      overwrite: 'Üzerine yaz',
      overwriteConfirm:
        'Bu alanda içerik var. Yapay zekânın önerisi mevcut içeriğin yerine geçecek (proje geçmişinde eski hâli tutulmaz). Devam edilsin mi?',
      claimsFound: 'Öneride {{count}} sağlık beyanı ifadesi bulundu; yayından önce düzeltin:',
      masked: 'Sağlayıcıya gönderilmeden önce {{count}} kişisel veri maskelendi.',
      truncated: 'Yanıt uzunluk sınırında kesildi; sonunu kontrol edin.',
      addHeading: 'Başlık ekle',
      removeHeading: 'Başlığı kaldır',
      linksTitle: 'İç bağlantılar',
      linksNone: 'Henüz iç bağlantı seçilmedi.',
      linkTypes: { product: 'Ürün', category: 'Kategori', post: 'Yazı' },
      removeLink: '{{title}} bağlantısını kaldır',
      suggest: 'Mağazadan öneri getir',
      suggestNone: 'Konuyla eşleşen yayındaki ürün, kategori veya yazı bulunamadı.',
      add: 'Ekle',
      added: 'Eklendi',
      relatedSuggested: 'Önerilen ürünler:',
      chars: '{{count}} / {{max}} karakter',
      schemaNote:
        'Yapılandırılmış veri (BlogPosting) blog yazısı yayımlanınca başlık, açıklama, kapak ve tarihlerden otomatik üretilir.',
      coverSet: 'Kapak seçildi',
      imagesNote:
        'Kapak blog yazısının kapağı olur; içerik görselleri "Taslağa ekle" ile taslakta istediğiniz yere konur ve aktarımda yazıya geçer.',
      aiCover: 'Yapay zekâ ile kapak görseli',
      aiImage: 'Yapay zekâ ile içerik görseli',
      imagePrompt: 'Görselde ne olsun?',
      imagePromptHint:
        'Kısa ve somut anlatın (ör. "parkta koşan mutlu golden retriever, sabah ışığı"). Görsele metin, logo, marka ve tanınabilir kişi eklenmez.',
      imageStyle: 'Tarz',
      imageStyles: { photo: 'Gerçekçi fotoğraf', illustration: 'İllüstrasyon' },
      imageSize: 'Boyut',
      imageSizes: { '1536x1024': 'Yatay (3:2)', '1024x1024': 'Kare', '1024x1536': 'Dikey (2:3)' },
      imageCost: 'Ücretli istektir; görsel başına harcama Yapay zekâ ayarlarındaki üst sınırı aşmaz.',
      generate: 'Görseli üret',
      imageDone: 'Görsel üretildi ve eklendi. Alt metnini yazın ve kaydedin.',
      aiGenerated: 'Yapay zekâ ile üretildi',
      aiAlt: 'Yapay zekâ ile alt metin',
      altDone: 'Alt metin önerisi alana yazıldı; görsele bakıp kontrol edin ve kaydedin.',
      insertToDraft: 'Taslağa ekle',
      inserted: 'Görsel taslağın sonuna eklendi; istediğiniz yere taşıyıp kaydedin.',
      provenance: 'Kaynak ve lisans',
      provenanceTitle: 'Görselin kaynağı ve lisansı',
      provenanceSource: 'Kaynak',
      provenanceSources: {
        own: 'Kendi çekimimiz / tasarımımız',
        licensed: 'Lisanslı (stok görsel)',
        supplier: 'Tedarikçi / marka',
        other: 'Diğer',
        ai_generated: 'Yapay zekâ ile üretildi',
      },
      provenanceNone: 'Kaynak bilgisi girilmedi.',
      provenanceLicense: 'Lisans',
      provenanceLicenseHint: 'Ör. "Stok görsel standart lisans", "CC BY 4.0".',
      provenanceCredit: 'Telif / atıf',
      provenanceUrl: 'Kaynak adresi',
      provenanceSaved: 'Kaynak bilgisi kaydedildi.',
      provenanceAiLocked:
        'Yapay zekâ ile üretilen görselin kaynağı değiştirilemez; vitrinde "yapay zekâ ile üretilmiş görsel" notuyla gösterilir.',
      provenanceModel: 'Model: {{model}} · {{date}}',
      qualityStatus: { pass: 'Tamam', warn: 'Uyarı', fail: 'Eksik' },
      quality: {
        title_length: 'Başlık {{length}} karakter (önerilen 30–70).',
        meta_length: 'Meta açıklama {{length}} karakter (önerilen 70–170).',
        slug: 'Adres (slug) belirlendi.',
        word_count: 'Taslak {{words}} kelime (en az {{min}}).',
        h1_in_body: 'Taslakta H1 yok (başlık ayrıca konur).',
        h2_count: '{{count}} H2 başlık (en az 2).',
        keyword_title: 'Anahtar kelime başlıkta geçiyor.',
        keyword_intro: 'Anahtar kelime giriş paragrafında geçiyor.',
        keyword_heading: 'Anahtar kelime en az bir ara başlıkta geçiyor.',
        keyword_density: 'Anahtar kelime yoğunluğu %{{percent}} (en çok %3).',
        keyword_missing: 'Anahtar kelime belirlenmedi.',
        internal_links: 'İç bağlantı: taslakta {{count}} (en az bir iç bağlantı önerilir).',
        sources_missing: 'Kaynak eklenmedi (sağlık içeriğinde zorunlu).',
        sources_broken: '{{count}} kaynağa erişilemiyor.',
        sources_unchecked: '{{count}} kaynak henüz doğrulanmadı.',
        sources_ok: '{{count}} kaynak doğrulandı.',
        cover: 'Kapak görseli ve alt metni.',
        image_alt: '{{count}} görselde alt metin eksik.',
        health_claims: 'Hastalık önleme/tedavi iddiası: {{count}} ifade.',
        duplicates_unchecked: 'Tekrar kontrolü yapılmadı.',
        duplicates_similar: 'Çok benzer içerik var: {{title}}.',
        duplicates_ok: 'Çok benzer içerik yok.',
        expert_review: 'Yayından önce Veteriner Uzman İnceleyici onayı gerekecek.',
      },
      qualityAfterSave: 'Kalite kontrolü kaydedilen hâle göre yapılır.',
      publishLead:
        'Aktarım, blogda bir taslak oluşturur ya da bağlı taslağı günceller. Yayın, editör ve Veteriner Uzman İnceleyici onayı ile zamanlı yayın blog ekranında yapılır; yayındaki yazı aktarımla değişmez.',
      export: 'Blog yazısına aktar',
      reexport: 'Blog taslağını güncelle',
      exported: 'Blog taslağı güncellendi.',
      openPost: 'Blog yazısını aç',
      archive: 'Projeyi arşivle',
      archiveConfirm: 'Proje arşive alınsın mı? Bağlı blog yazısı etkilenmez.',
      archivedDone: 'Proje arşivlendi.',
      perf: {
        not_exported: 'Performans, yazı bloga aktarılıp yayımlandıktan sonra görünür.',
        not_live: 'Blog yazısı henüz yayında değil.',
        no_permission: 'Search Console verisini görme yetkiniz yok.',
        not_linked: 'Search Console bağlı değil (Kurulum Gerekli): Google bağlantıları ekranından bağlayın.',
        no_data: 'Search Console verisi henüz senkronlanmadı.',
      },
      perfRange: 'Son veri: {{from}} – {{to}}',
      perfPeriod: 'Dönem',
      periods: { current: 'Son 28 gün', previous: 'Önceki 28 gün' },
      clicks: 'Tıklama',
      impressions: 'Gösterim',
      ctr: 'Tıklama oranı',
      position: 'Ortalama konum',
      notComparable: 'Karşılaştırma için önceki dönemin verisi eksik.',
      queries: 'Bu yazıyı getiren aramalar (son 28 gün)',
      queryStats: '· {{clicks}} tıklama · {{impressions}} gösterim',
      suggestionsTitle: 'Güncelleme önerileri',
      suggestionsNone: 'Şu an öneri yok.',
      suggestions: {
        stale: 'Yazı {{days}} gündür güncellenmedi; bilgileri ve kaynakları gözden geçirin.',
        traffic_drop:
          'Tıklamalar önceki 28 güne göre düştü ({{previous}} → {{current}}). Arama sorgularını ve içeriğin güncelliğini kontrol edin.',
        low_ctr:
          '{{impressions}} gösterimde tıklama oranı %{{ctr}}: SEO başlığını ve meta açıklamayı daha açıklayıcı yapın.',
        near_first_page:
          'Ortalama konum {{position}}: ilk sayfaya yakın. İçeriği genişletip ilgili sayfalardan iç bağlantı verin.',
        missing_queries:
          'Yazıda geçmeyen arama sorguları: {{queries}}. Uygunsa bu sorulara bir bölüm ekleyin.',
        sources_recheck: 'Kaynaklar 6 aydır doğrulanmadı; bağlantıları yeniden kontrol edin.',
      },
    },
    drafts: {
      copy: 'Kopyala',
      copied: 'Kopyalandı.',
      generate: 'Taslak üret',
      again: 'Yeniden üret',
      apply: 'Alanlara uygula',
      applied: 'Taslak forma yazıldı; kontrol edip kaydedin.',
      reviewNote:
        'Taslaktır: yalnızca ürünün kayıtlı bilgileri kullanıldı. Yayından önce okuyun; sağlık içeriği veteriner onayından geçer.',
      productDescription: 'Yapay zekâ ile açıklama taslağı',
      productLead:
        'Kısa ve uzun açıklama, ürünün kayıtlı bilgilerinden (ad, marka, tür, kategori, özellikler, bileşim, kullanım, uyarılar) yazılır. Ücretli istektir.',
      tone: 'Üslup',
      tones: { informative: 'Bilgilendirici', friendly: 'Samimi' },
      notes: 'Vurgulanacak nokta (isteğe bağlı)',
      translate: 'Yapay zekâ ile çevir',
      translateFrom: 'Kaynak dil',
      translated: 'Çeviri forma yazıldı; kontrol edip kaydedin.',
      email: 'Yapay zekâ ile konu önerisi',
      goal: 'Kampanyanın amacı',
      goalHint: 'Ör. "Kış aylarında eklem desteği ürünlerini hatırlatmak".',
      audience: 'Hedef kitle (isteğe bağlı)',
      products: 'Öne çıkan ürünler (isteğe bağlı)',
      subjects: 'Konu önerileri',
      useAsA: 'Konu yap',
      useAsB: 'B konusu yap',
      preheader: 'Ön metin',
      use: 'Kullan',
      intro: 'Giriş paragrafı',
      introNote: 'Giriş paragrafını e-posta şablonunun metnine kopyalayabilirsiniz.',
      supportReply: 'Yapay zekâ ile yanıt taslağı',
      replyDone: 'Yanıt taslağı alana yazıldı; okuyup düzenleyin, sonra gönderin.',
      adSuggestions: 'Reklam önerileri',
      adSuggestionsLead:
        'Gerçek sipariş gelirine göre kurallı bulgular (ücretsiz). İsterseniz yapay zekâ bulguları yalnızca bu sayılarla özetler (ücretli). Bütçe ve yayın değişikliği her zaman değişiklik talebi ve onayla yapılır.',
      period: 'Dönem',
      lastDays: 'Son {{days}} gün',
      findings: 'Bulguları göster',
      summarize: 'Yapay zekâ ile özetle',
      noAdData: 'Bu dönemde reklam verisi yok. Reklam hesabı bağlayın veya rapor dosyası yükleyin.',
      noFindings: 'Dikkat gerektiren bulgu yok.',
      findingKinds: {
        no_orders: 'Siparişsiz harcama',
        roas_below_1: "ROAS 1'in altında",
        low_ctr: 'Düşük tıklama oranı',
        scale_candidate: 'Büyütülebilir',
        anomaly: 'Anomali',
      },
      anomalies: {
        no_clicks: 'tıklamasız harcama',
        spend_spike: 'harcama sıçraması',
        ctr_drop: 'tıklama oranı düştü',
        sync_failed: 'senkron hatası',
        sync_stale: 'veri güncel değil',
      },
      aiSummary: 'Yapay zekâ özeti',
      adChangeNote:
        'Öneridir: reklam oluşturulmaz, bütçe veya yayın değişmez. Değişiklik için değişiklik talebi oluşturup onaya sunun.',
      adCopy: 'Reklam metni taslağı',
      product: 'Ürün',
      platform: 'Platform',
      platforms: { google: 'Google duyarlı arama reklamı', meta: 'Meta (Facebook / Instagram)' },
      pickProduct: 'Önce bir ürün seçin.',
      primaryTexts: 'Ana metinler',
      headlines: 'Başlıklar',
      descriptions: 'Açıklamalar',
      maxChars: 'en çok {{max}} karakter',
      dropped: '{{count}} satır karakter sınırını aştığı için atıldı.',
      adEmpty: 'Kullanılabilir metin çıkmadı',
      adEmptyLead: 'Yeniden üretmeyi deneyin.',
    },
    copilot: {
      lead: 'İşletmenizin verilerinden hesaplanan içgörüler (ücretsiz, yapay zekâsız) ve bu verilerle yanıt veren asistan. Copilot hiçbir kaydı değiştirmez; yalnızca görme yetkiniz olan veriler kullanılır.',
      period: 'Dönem',
      copyReport: 'Yönetim raporu olarak kopyala',
      reportTitle: 'Yönetim özeti ({{from}} – {{to}})',
      insightsTitle: 'İçgörüler',
      noInsights: 'Henüz içgörü yok',
      noInsightsLead: 'Satış, stok veya reklam verisi oluştukça burada görünür.',
      severity: { good: 'İyi', info: 'Bilgi', warn: 'Dikkat' },
      sectionsNote: 'Yetkiniz olmadığı için dahil edilmeyen bölümler: {{hidden}}.',
      sections: {
        stock: 'stok',
        seo: 'SEO',
        customers: 'müşteri segmentleri',
        ads: 'reklam',
        cost: 'maliyet ve marj',
        finance: 'net kâr',
      },
      insights: {
        no_sales: 'Bu ve önceki dönemde ödenmiş sipariş yok; satış içgörüsü üretilemiyor.',
        revenue_change:
          'Ürün geliri {{current}} (önceki dönem {{previous}}, değişim %{{change}}); {{orders}} sipariş (önceki {{previousOrders}}).',
        aov_change: 'Ortalama sepet {{current}} (önceki {{previous}}, değişim %{{change}}).',
        decline_drivers: 'Düşüşe en çok katkı yapan ürünler: {{products}}.',
        refund_rate: 'İade/iptal oranı %{{rate}}: iade nedenlerini inceleyin.',
        new_customers: "Siparişlerin %{{share}}'i yeni müşteriden ({{count}} sipariş).",
        margin_down: 'Brüt marj %{{previous}} → %{{current}}: maliyet artışı veya indirimleri kontrol edin.',
        margin_unknown: 'Marj hesaplanamadı: satılan ürünlerin bir kısmında maliyet girilmemiş.',
        quiet_days:
          'Bu dönemin {{days}} gününün yalnızca {{active}} gününde sipariş var; önceki dönem daha düzenliydi.',
        stock_needs: '{{stockout}} varyant tükendi, {{reorder}} varyantta sipariş zamanı geldi: {{items}}.',
        expiry_risk: '{{count}} varyantta son kullanma tarihine kadar satılamayacak stok riski var.',
        seo_not_linked: 'Search Console bağlı değil; SEO fırsatları hesaplanamıyor.',
        seo_opportunities: 'İlk sayfaya yakın ama az tıklanan aramalar (gösterim, konum): {{queries}}.',
        segment_at_risk:
          '{{count}} değerli müşteri kaybedilmek üzere (RFM "risk altında" ve "kaybedilmemeli"): geri kazanım kampanyası düşünün.',
        segment_champions: '{{count}} şampiyon müşteri: sadakat veya tavsiye programına davet edin.',
        ads_roas: 'Reklam harcaması {{spend}}, reklamdan gelen ürün geliri {{revenue}} (ROAS {{roas}}).',
        ads_anomalies: '{{count}} reklam anomalisi var: Reklam merkezini kontrol edin.',
        net_profit:
          'Net kâr {{current}} (önceki dönem {{previous}}, değişim %{{change}}); net kâr marjı %{{margin}}.',
        net_profit_partial:
          'Net kâr eksik veriyle hesaplandı: maliyeti girilmemiş satış {{revenue}}, kargo maliyeti bilinmeyen {{shipments}} gönderi, komisyonu bilinmeyen {{payments}} ödeme (Raporlar → Finans raporu).',
      },
      salesTitle: 'Satış özeti ({{from}} – {{to}})',
      metric: 'Ölçü',
      current: 'Bu dönem',
      previous: 'Önceki dönem',
      metrics: {
        orders: 'Sipariş',
        revenue: 'Ürün geliri (KDV ve kargo hariç)',
        refunded: 'İade / iptal',
        newCustomers: 'Yeni müşteri',
      },
      topProducts: 'En çok satanlar',
      profitTitle: 'Net kâr ({{from}} – {{to}})',
      profitLead:
        'Finans raporuyla aynı hesap: KDV hariç, Türk lirası. Net kâr = brüt kâr − kargo − ödeme komisyonu − reklam − kaybedilen itirazlar − işletme giderleri.',
      profitMetrics: {
        revenueMinor: 'Ürün geliri (KDV hariç)',
        grossProfitMinor: 'Brüt kâr',
        shippingMinor: 'Kargo maliyeti',
        feesMinor: 'Ödeme komisyonu',
        adsMinor: 'Reklam harcaması',
        disputesMinor: 'Kaybedilen itirazlar',
        expensesMinor: 'İşletme giderleri',
        netProfitMinor: 'Net kâr',
        netBps: 'Net kâr marjı',
      },
      percent: '%{{value}}',
      askTitle: "Copilot'a sorun",
      askLead:
        'Yanıt yalnızca yukarıdaki hesaplanmış verilerle verilir (müşteri adı, e-posta veya adres gönderilmez). Veri yoksa Copilot bunu söyler; hiçbir işlem yapmaz. Her soru ücretli bir istektir.',
      conversation: 'Konuşma',
      you: 'Siz',
      copilot: 'Copilot',
      question: 'Sorunuz',
      questionHint:
        'Ör. "Satışlar neden düştü?", "Hangi ürünlerin stoğunu yenilemeliyim?", "Bu ay için 3 öneri ver."',
      ask: 'Sor',
      clear: 'Konuşmayı temizle',
    },
    seo: {
      lead: 'Anahtar kelime havuzunuz ve Search Console verinizden yapay zekâsız öneriler: otomatik kümeler, konu haritası, uzun kuyruklu aramalar, içerik boşlukları ve Google ürün başlıkları.',
      notSynced:
        'Search Console verisi yok: gösterim sayıları ve uzun kuyruk önerileri boş kalır. Google bağlantıları ekranından bağlayın.',
      clustersTitle: 'Otomatik kümeler',
      noProposals: 'Önerilecek yeni küme yok.',
      emptyPool: 'Anahtar kelime havuzu boş. SEO → Anahtar kelimeler ekranından ekleyin.',
      keywordCount: '({{count}} kelime)',
      applyClusters: 'Seçilen {{count}} kümeyi uygula',
      applied: '{{count}} kelimenin kümesi güncellendi.',
      topicsTitle: 'Konu haritası (ana sayfa ve destek içerikleri)',
      noTopics: 'Kümesi olan anahtar kelime yok. Önce kümeleri uygulayın.',
      pillar: 'ana kelime: {{keyword}} → {{path}}',
      noPage: 'sayfa yok',
      link: {
        yes: 'Ana sayfaya bağlantı var',
        no: 'Ana sayfaya bağlantı eksik',
        unknown: 'Kontrol edilemedi',
      },
      missingContent: '{{count}} kelimenin hedef sayfası yok.',
      longTailTitle: 'Uzun kuyruklu aramalar',
      noLongTail: 'Havuzda olmayan, en az 3 kelimelik ve 10+ gösterimli arama yok.',
      query: 'Arama',
      pick: '{{query}} seç',
      addToPool: 'Seçilen {{count}} aramayı havuza ekle',
      added: 'Havuza eklendi.',
      gapsTitle: 'İçerik boşlukları',
      noGaps: 'Hedef sayfası olmayan anahtar kelime yok.',
      createProject: 'Makale projesi oluştur',
      openProject: 'Projeyi aç',
      titlesTitle: 'Google ürün başlıkları',
      titlesLead:
        "Merchant Center'a giden başlık: en çok 150 karakter, önemli bilgi başta, marka ve ürün türü, tanıtım metni ve tamamı büyük harf yok. Boş bırakılırsa ürün adı gönderilir.",
      onlyIssues: 'Yalnızca sorunlu olanlar',
      noTitleIssues: 'Sorunlu başlık yok.',
      currentTitle: 'Şu anki başlık',
      suggested: 'Öneri',
      aiSuggested: 'Yapay zekâ önerisi',
      applyTitle: 'Uygula',
      aiTitle: 'Yapay zekâ ile başlık',
      resetTitle: 'Ürün adına dön',
      titleSaved: 'Google başlığı kaydedildi; bir sonraki feed gönderiminde geçerli olur.',
      issues: {
        too_long: '150 karakteri aşıyor',
        too_short: 'Çok kısa',
        promo_text: 'Tanıtım ifadesi var',
        all_caps: 'Tamamı büyük harf',
        brand_missing: 'Marka yok',
        symbols: 'Gereksiz sembol / emoji',
        health_claim: 'Sağlık iddiası',
      },
    },
    youtube: {
      lead: "Ürünlerde ve blog yazılarında kullanılan YouTube videolarının herkese açık bilgileri YouTube Data API ile okunur (yalnızca okuma, ücretsiz günlük kota; yapay zekâ değildir). Vitrinde arama motorları için video bilgisi (küçük resim, yükleme tarihi, süre) eklenir; kaldırılmış, gömülmeye kapatılmış veya Türkiye'de engelli videolar vitrinde gösterilmez.",
      connectionTitle: 'Bağlantı',
      notConfigured:
        'YouTube Data API anahtarı girilmedi. Videolar vitrinde eskisi gibi gösterilir; yalnızca video bilgisi ve uyarılar olmaz.',
      connectionError:
        'Son denemede YouTube anahtarı reddedildi veya API kapalı. Entegrasyonlar ekranından anahtarı kontrol edip yeniden test edin.',
      toIntegrations: 'Anahtarı Entegrasyonlar ekranından girin',
      connected: 'Bağlı',
      lastSync: 'Son senkron: {{date}}',
      neverSynced: "Henüz senkron yapılmadı (her gece 05:50'de yapılır).",
      syncNow: 'Şimdi senkronla',
      synced: '{{count}} videonun bilgisi güncellendi.',
      logsTitle: 'Son senkronlar',
      outcome: { success: 'Başarılı', failure: 'Hata', blocked: 'Engellendi' },
      logOk: '{{videos}} video, {{requests}} istek',
      videosTitle: 'Kullanılan videolar',
      noVideos: 'Ürünlerde ve blog yazılarında YouTube videosu yok.',
      summary: '{{count}} video · {{problems}} sorunlu',
      onlyIssues: 'Yalnızca sorunlu olanlar',
      status: {
        available: 'Yayında',
        processing: 'İşleniyor',
        not_embeddable: 'Gömülemez',
        region_blocked: "Türkiye'de engelli",
        unavailable: 'Kaldırılmış veya gizli',
        unknown: 'Bilgi alınmadı',
      },
      problem: {
        not_embeddable: 'Video sahibi başka sitelerde oynatmayı kapatmış; vitrinde gösterilmiyor.',
        region_blocked: "Video Türkiye'de izlenemiyor; vitrinde gösterilmiyor.",
        unavailable:
          'Video silinmiş, gizlenmiş veya reddedilmiş; vitrinde gösterilmiyor. Ürün veya yazıdan kaldırın ya da değiştirin.',
      },
      published: 'Yayın: {{date}}',
      open: "YouTube'da aç",
      usedBy: 'Kullanıldığı yer:',
      product: 'Ürün: {{name}}',
      post: 'Yazı: {{name}}',
    },
    ltv: {
      lead: 'Müşterilerin önümüzdeki 12 ayda beklenen harcaması, sipariş geçmişlerinden açıklanabilir bir modelle hesaplanır (yapay zekâ ve dış hizmet yok). Veri RFM hesaplamasıyla (her gece) güncellenir.',
      empty: 'Henüz hesaplanmış müşteri verisi yok',
      emptyLead: 'Müşteri segmentleri ekranında RFM hesaplandıktan sonra burada görünür.',
      summaryTitle: 'Özet',
      computedAt: 'Son hesaplama',
      customers: 'Müşteri',
      modeledOf: '{{modeled}} / {{total}} müşteri için tahmin',
      total: '12 ayda beklenen toplam harcama (mevcut müşteriler)',
      repeatRate: 'Tekrar alım oranı',
      repeatUnknown:
        'Tek siparişli müşteriler için tahmin yok (en az {{min}} müşteri gerekir; şu an {{count}})',
      repeatValue: '%{{rate}} · tekrar alanlarda ortanca aralık {{days}} gün',
      top10: "En değerli %10'un beklenen harcamadaki payı",
      cac: 'Reklamla edinme maliyeti (son 90 gün)',
      cacValue: 'Yeni müşteri başı {{cac}} · yeni müşterinin 12 aylık beklenen değeri {{ltv}}',
      segmentsTitle: 'Segmentlere göre',
      segment: 'Segment',
      avgHistoric: 'Ortalama geçmiş harcama',
      avgPredicted: 'Ortalama beklenen (12 ay)',
      topTitle: 'Beklenen değeri en yüksek müşteriler',
      hiddenName: 'Müşteri (ad görme yetkiniz yok)',
      orders: '{{count}} sipariş',
      predictedLine: '{{value}} · ~{{orders}} sipariş',
      customerCell: 'Beklenen değer (12 ay)',
      customerCellSub: '~{{orders}} sipariş bekleniyor · Müşteri Değeri ekranında model açıklanır',
    },
    settings: {
      statusTitle: 'Durum',
      statusLead:
        'Yapay zekâ ücretli bir dış hizmettir. Anahtar girilse bile, siz aylık harcama sınırını yazıp açık onay verene kadar hiçbir istek gönderilmez.',
      on: 'Açık',
      off: 'Kapalı',
      enabledBy: '{{name}} tarafından {{date}} tarihinde açıldı',
      textProvider: 'Metin (Anthropic Claude)',
      imageProvider: 'Görsel (OpenAI Images)',
      toIntegrations: 'Anahtarı Entegrasyonlar ekranından girin',
      enable: 'Yapay zekâyı aç',
      disable: 'Kapat',
      disabled: 'Yapay zekâ kapatıldı. Bekleyen istek yoksa hiçbir ücret oluşmaz.',
      enableTitle: 'Yapay zekâyı aç',
      enableLead:
        'Açtığınızda yetkili kullanıcılar taslak üretebilir ve sağlayıcı (Anthropic/OpenAI) istek başına ücret alır. Sistem aylık sınıra ulaşınca durur.',
      enableLimit: 'Aylık harcama sınırı (USD)',
      enableLimitHint: 'Tahmini harcama bu tutara ulaşınca yeni istek gönderilmez. En az 1 USD.',
      enableAck:
        'Bu hizmetin ücretli olduğunu, ücretin sağlayıcıya ödendiğini ve sınır içinde harcama yapılacağını onaylıyorum.',
      enableProviderNote:
        'Sağlayıcının kendi panelinde de (Anthropic Console, OpenAI limitleri) bir harcama sınırı koymanızı öneririz: sistemin sınırı tahmine dayanır.',
      enableSubmit: 'Onaylıyorum, aç',
      enabled: 'Yapay zekâ açıldı.',
      monthTitle: 'Bu ay',
      spent: 'Tahmini harcama',
      spentOf: '{{spent}} / {{limit}}',
      noLimit: 'Sınır tanımlı değil',
      requests: 'İstek',
      requestsToday: 'Bugün {{count}} / {{limit}}',
      estimateNote:
        'Tutarlar token sayıları ve aşağıdaki fiyat tablosundan hesaplanan tahmindir; kesin tutar sağlayıcı faturasıdır.',
      configTitle: 'Ayarlar',
      monthlyLimit: 'Aylık harcama sınırı (USD)',
      dailyLimit: 'Günlük istek sınırı',
      textModel: 'Metin modeli',
      lightModel: 'Kısa işler için model',
      lightModelHint: 'Başlık, meta açıklama ve alt metin gibi kısa işlerde kullanılır (daha ucuz).',
      imageModel: 'Görsel modeli',
      imageQuality: 'Görsel kalitesi',
      imageQualities: { low: 'Düşük', medium: 'Orta', high: 'Yüksek' },
      imageReserve: 'Görsel başına üst sınır (USD)',
      imageReserveHint:
        'Görsel isteği öncesi ayrılan tutar; sağlayıcı token sayısı bildirmezse maliyet bu kabul edilir.',
      supportDrafts: 'Destek yanıt taslaklarında müşteri mesajını gönder',
      supportDraftsHint:
        'Mesajdaki e-posta, telefon, kimlik no, IBAN ve kart numarası maskelenir; ad ve adres ayıklanamaz. Açmadan önce KVKK yurt dışı aktarım envanterini ve aydınlatma metnini avukatınızla güncelleyin.',
      save: 'Ayarları kaydet',
      saved: 'Ayarlar kaydedildi.',
      pricesTitle: 'Fiyat tablosu',
      pricesLead:
        'Varsayılan fiyatlar {{date}} tarihinde sağlayıcıların fiyat sayfalarından alındı. Sağlayıcı fiyat değiştirirse buradan güncelleyin.',
      model: 'Model',
      kind: 'Tür',
      kinds: { text: 'Metin', image: 'Görsel' },
      inputPrice: 'Girdi / 1 M token',
      outputPrice: 'Çıktı / 1 M token',
      custom: 'Özel fiyat',
      unknownPrice: 'Fiyat yok',
      editPrice: 'Fiyatı düzenle',
      resetPrice: 'Varsayılana dön',
      priceTitle: '{{model}} fiyatı',
      priceSaved: 'Fiyat kaydedildi.',
      usageTitle: 'Kullanım',
      usageLead: 'Sağlayıcıya giden her istek. İstem ve yanıt metni kaydedilmez.',
      month: 'Ay',
      totals: '{{requests}} istek · {{ok}} başarılı · {{errors}} hata · {{cost}}',
      tokens: '{{input}} girdi / {{output}} çıktı token',
      byPurpose: 'Amaca göre',
      purpose: 'Amaç',
      cost: 'Maliyet',
      recent: 'Son istekler',
      when: 'Zaman',
      user: 'Kullanıcı',
      status: 'Sonuç',
      masked: 'Maskelenen',
      claims: 'Sağlık beyanı',
      noUsage: 'Bu ay istek yok.',
      system: 'Sistem',
    },
  },
  integrationMessages: {
    youtube_ok: 'Anahtar doğrulandı (bölge listesi okundu; 1 kota birimi, ücretsiz).',
    youtube_key_format: 'API anahtarı biçimi hatalı ("AIza" ile başlar, 39 karakter).',
    youtube_key_invalid: 'Google bu API anahtarını kabul etmedi.',
    youtube_key_restricted:
      'Anahtarın tarayıcı/uygulama kısıtı sunucudan kullanımı engelliyor (IP kısıtı kullanın).',
    youtube_api_disabled: 'Google Cloud projesinde YouTube Data API v3 etkin değil.',
    youtube_quota: 'YouTube günlük kotası doldu.',
    youtube_unreachable: "YouTube'a ulaşılamadı.",
    ai_text_ok: 'Anahtar doğrulandı (model listesi okundu; ücret oluşmadı).',
    ai_image_ok: 'Anahtar doğrulandı (model listesi okundu; ücret oluşmadı).',
    ai_invalid_key: 'Sağlayıcı API anahtarını reddetti.',
    ai_invalid_settings: 'API anahtarı boş veya geçersiz biçimde.',
    ai_provider_rate_limited: 'Sağlayıcı istek sınırına takıldı; biraz sonra yeniden deneyin.',
    ai_provider_overloaded: 'Sağlayıcı şu an yoğun; biraz sonra yeniden deneyin.',
    ai_provider_rejected: 'Sağlayıcı isteği reddetti.',
    ai_provider_timeout: 'Sağlayıcı zamanında yanıt vermedi.',
    ai_provider_unreachable: 'Sağlayıcıya ulaşılamadı.',
    ai_provider_bad_response: 'Sağlayıcının yanıtı okunamadı.',
  },
  integrations: {
    ai_text: {
      name: 'Yapay zekâ (metin) — Anthropic Claude',
      description:
        'Ürün açıklaması, makale ve e-posta taslakları, çeviri ve Copilot. Ücretli; kullanım Yapay zekâ ayarlarında sahip onayı ve aylık sınır ister.',
    },
    ai_image: {
      name: 'Yapay zekâ (görsel) — OpenAI Images',
      description:
        'Makale kapak ve içerik görselleri. Ücretli; kullanım Yapay zekâ ayarlarında sahip onayı ve aylık sınır ister.',
    },
    youtube: {
      name: 'YouTube Data API',
      description:
        'Ürün ve blog videolarının bilgisi (küçük resim, süre, yayın durumu): vitrinde video yapılandırılmış verisi, kaldırılmış videoların gizlenmesi ve uyarısı. Yalnızca okuma, API anahtarı; ücretsiz günlük kota.',
    },
  },
  permissions: {
    'ai.generate': 'Yapay zekâ ile taslak üretme (ücretli hizmet)',
    'ai.usage.read': 'Yapay zekâ kullanımını ve maliyetini görüntüleme',
    'ai.settings.manage': 'Yapay zekâyı açma/kapatma ve harcama sınırı',
  },
  permissionModules: { ai: 'Yapay zekâ' },
  integrationFields: { organizationId: 'Organizasyon kimliği (isteğe bağlı, org-…)' },
  auditActions: {
    'seo.keywords_clustered': 'Anahtar kelime kümeleri uygulandı',
    'catalog.product.merchant_title': 'Google ürün başlığı değiştirildi',
    'file.ai_generated': 'Yapay zekâ ile görsel üretildi',
    'file.provenance_update': 'Görsel kaynak ve lisans bilgisi güncellendi',
    'article_project.create': 'Makale projesi oluşturuldu',
    'article_project.update': 'Makale projesi güncellendi',
    'article_project.archive': 'Makale projesi arşivlendi',
    'article_project.exported': 'Makale projesi bloga aktarıldı',
    'article_project.ai_step': 'Makale projesinde yapay zekâ adımı',
    'article_project.sources_checked': 'Makale kaynakları doğrulandı',
    'article_project.duplicates_checked': 'Makale tekrar kontrolü yapıldı',
    'ai.enabled': 'Yapay zekâ açıldı',
    'ai.disabled': 'Yapay zekâ kapatıldı',
    'ai.settings_update': 'Yapay zekâ ayarları güncellendi',
    'recommendations.settings_update': 'Öneri ayarları güncellendi',
    'recommendations.recomputed': 'Öneriler yeniden hesaplandı',
    'forecast.settings_update': 'Talep tahmini ayarları güncellendi',
    'forecast.variant_update': 'Varyantın tahmin ayarı güncellendi',
  },
} as const;
